import { render, staticRenderFns } from "./PrettyListItemMenu.vue?vue&type=template&id=c18db880&"
import script from "./PrettyListItemMenu.vue?vue&type=script&lang=ts&"
export * from "./PrettyListItemMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports